import {z as zod} from "zod";

export type ProductInventoryWorkspaceCapabilityConfiguration = Record<string, never>;

export const productInventoryWorkspaceCapabilityConfigurationValidator: zod.ZodType<ProductInventoryWorkspaceCapabilityConfiguration> = zod.strictObject({});
